import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { EventsApiService, UpdateEventDetailsDTO } from 'features/events';
import { queryClient } from 'providers';

import { eventsQueryKeys } from './query-keys';

const { updateEventDetails } = EventsApiService();

export const useUpdateEventDetails = () => {
    const { message } = App.useApp();

    return useMutation(
        (payload: UpdateEventDetailsDTO) => {
            return updateEventDetails(payload);
        },
        {
            onError: (error) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            onSuccess: () => {
                queryClient.invalidateQueries({
                    queryKey: eventsQueryKeys.all,
                });
                message.success('Event Details has been updated successfully!!');
            },
        },
    );
};
